
export function createRedirectManager ({dispatch, actions, history}) {
  return {
    redirectBackWith: (methodName) => {
      const location = (history||window).location
      const here = location.pathname
      const to = (location.state||{}).from || '/'
      const action = actions[methodName](to)
      console.log('redirector:', here, to, action)
      if (to !== here) dispatch(action)
    },
    redirectWith: (methodName, to, andBack) => {
      const location = (history||window).location
      const { pathname:here } = location
      const action = actions[methodName](to, andBack ? {from: here} : {})
      console.log('redirector:', here, to, action)
      if (to !== here) dispatch(action)
    },
    push: (to, ...args) => {
      const location = history.location||window.location
      console.log('redirector:', actions, location, location.pathname, to, 'push')
      if (to !== location.pathname)
        dispatch(actions.push(to, ...args))
    },
    replace: (to, ...args) => {
      const location = (history||window).location
      console.log('redirector:', location.pathname, to, 'replace')
      if (to !== location.pathname)
        dispatch(actions.replace(to, ...args))
    }
  }
}



// WEBPACK FOOTER //
// ./src/App.redirector.js